import React from 'react';
import { Box, Typography, FlexBox, Button, color } from '@kis-technologies/kis-ui';
import { Requirements } from './VideoRequirements';

interface VideoMediaDetailsProps {
  mediaType?: string;
  video?: string;
  error: string | null;
  onAddVideoClick: () => void;
  onVideoDelete: () => void;
  isLoading: boolean;
}

export const VideoMediaDetails: React.FC<VideoMediaDetailsProps> = (props: VideoMediaDetailsProps) => {
  const { video, mediaType, error, onAddVideoClick, onVideoDelete, isLoading } = props;
  return (
    <Box>
      <Typography fontSize={18}>File Details</Typography>
      <Typography fontSize={14}>Name: {video}</Typography>
      <Box margin="6 0" />
      <Requirements videoType={mediaType} />
      {error && (
        <Box margin="3 0">
          <Typography fontSize={16} color={color.RED}>
            {error}
          </Typography>
        </Box>
      )}
      <FlexBox direction="row" align="center" gutter={2}>
        <Button
          customSize="x-small"
          width={200}
          onClick={onAddVideoClick}
          isLoading={isLoading}
          appearance="primary"
          data-testid="add-video-button"
        >
          Select Different Video
        </Button>
        <Button
          customSize="x-small"
          width={200}
          appearance="white"
          onClick={onVideoDelete}
          isLoading={isLoading}
          data-testid="delete-video-button"
        >
          Delete
        </Button>
      </FlexBox>
    </Box>
  );
};
